import { FC } from 'react';
import css from './HeaderSection.module.scss';
import { FamilyStep, STEPS } from 'redux/familyBookingSlice';
import { useAppSelector } from 'redux/reduxHooks';

interface HeaderSectionProps {
  /** Only the family booking flow drives this; SingleBooking omits it. */
  currentStep?: FamilyStep;
  title: string;
}

const HeaderSection: FC<HeaderSectionProps> = ({
  currentStep,
  children,
  title,
}) => {
  const { isFamilyBookingEnabled } = useAppSelector(
    (state) => state.clinicDetailsSlice.clinicData
  );

  // The slot picker owns the whole panel, so it gets a bare heading.
  if (currentStep === STEPS.SLOT_SELECTION) {
    return (
      <div className={css['select-time-header-section']}>
        <h3 className={css['title']}>{title}</h3>
      </div>
    );
  }

  if (!isFamilyBookingEnabled) {
    return (
      <div className={css['header-section']}>
        <h3 className={css['title']}>{title}</h3>
      </div>
    );
  }

  return (
    <div className={css['header-section']}>
      <h3 className={css['title']}>{title}</h3>

      {children}
    </div>
  );
};

export default HeaderSection;
